import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FELDER = [
  ["tage_bis_stufe1", "1. Mahnung nach Tagen Verzug"],
  ["tage_bis_stufe2", "2. Mahnung Tage nach 1. Mahnung"],
  ["tage_bis_inkasso", "Inkasso Tage nach 2. Mahnung"],
  ["frist_0", "Frist Erinnerung (Tage)"],
  ["frist_1", "Frist 1. Mahnung (Tage)"],
  ["frist_2", "Frist 2. Mahnung (Tage)"],
  ["gebuehr_0", "Gebühr Erinnerung (€)"],
  ["gebuehr_1", "Gebühr 1. Mahnung (€)"],
  ["gebuehr_2", "Gebühr 2. Mahnung (€)"],
  ["verzugspauschale", "Verzugspauschale ab 1. Mahnung (€)"],
];

const RegelZeile = ({ regel, darfAendern, onSaved }) => {
  const [w, setW] = useState(regel);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    const leer = FELDER.find(([k]) => w[k] === "" || w[k] === null || Number.isNaN(Number(w[k])));
    if (leer) { toast.error(`Bitte „${leer[1]}“ ausfüllen`); return; }
    setBusy(true);
    try {
      const { data } = await axios.put(`${API}/mahnregeln/${regel.typ}`, w);
      toast.success(`Mahnregel „${data.typ_label}“ gespeichert`);
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Speichern fehlgeschlagen");
    } finally { setBusy(false); }
  };
  return (
    <div className="border border-[#E0D6CA] rounded-md p-3" data-testid={`mahnregel-${regel.typ}`}>
      <div className="flex items-center justify-between mb-2 gap-2 flex-wrap">
        <span className="font-medium text-sm text-[#3D3835]">{regel.typ_label}</span>
        <label className="text-xs flex items-center gap-1">
          <input type="checkbox" checked={!!w.mahnen} disabled={!darfAendern}
            onChange={(e) => setW({ ...w, mahnen: e.target.checked })} data-testid={`mahnregel-${regel.typ}-mahnen`} />
          im Mahnlauf vorschlagen
        </label>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        {FELDER.map(([k, label]) => (
          <label key={k} className="text-xs text-[#5C534D]">
            {label}
            <input type="number" min="0" step={k.startsWith("gebuehr") || k === "verzugspauschale" ? "0.01" : "1"}
              value={w[k]} disabled={!darfAendern}
              onChange={(e) => setW({ ...w, [k]: e.target.value })}
              className="mt-0.5 w-full border border-[#E0D6CA] rounded px-2 py-1 text-sm text-[#3D3835]"
              data-testid={`mahnregel-${regel.typ}-${k}`} />
          </label>
        ))}
      </div>
      {darfAendern && (
        <button onClick={save} disabled={busy} data-testid={`mahnregel-${regel.typ}-speichern`}
          className="mt-2 text-xs px-3 py-1 rounded bg-[#3D3835] text-white hover:bg-black transition-colors disabled:opacity-50">
          {busy ? "Speichert…" : "Speichern"}
        </button>
      )}
      {regel.geaendert_am && <div className="text-[10px] text-[#8E7B71] mt-1">zuletzt geändert am {new Date(regel.geaendert_am).toLocaleString("de-DE")} von {regel.geaendert_von}</div>}
    </div>
  );
};

export const MahnregelnPanel = ({ role, onChanged }) => {
  const [regeln, setRegeln] = useState(null);
  const darfAendern = role === "gf" || role === "verwaltung";
  const load = () => axios.get(`${API}/mahnregeln`).then((r) => setRegeln(r.data.regeln)).catch(() => setRegeln([]));
  useEffect(() => { load(); }, []);
  if (!regeln) return <div className="text-sm text-[#8E7B71] italic py-2">Lade Mahnregeln…</div>;
  return (
    <div className="space-y-3 mb-4" data-testid="mahnregeln-panel">
      {!darfAendern && <div className="text-xs text-[#8E7B71]">Nur Geschäftsführung und Verwaltung können die Regeln ändern.</div>}
      {regeln.map((r) => (
        <RegelZeile key={r.typ} regel={r} darfAendern={darfAendern} onSaved={() => { load(); onChanged && onChanged(); }} />
      ))}
    </div>
  );
};
